import React, { useState, useEffect, useRef } from 'react';

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
@import url('https://api.fontshare.com/v2/css?f[]=clash-display@400,500,600,700&display=swap');
:root{--navy:#06112b;--navy2:#0d1f45;--navy3:#112359;--blue:#1c73ba;--blue2:#2b8de0;--blue3:#5aaef7;--gold:#f5a623;--gold2:#ffc94d;--muted:#94a3b8;--border:rgba(28,115,186,0.15);}
.pc-page{min-height:100vh;background:linear-gradient(145deg,var(--navy) 0%,var(--navy3) 60%,#1a3570 100%);font-family:'DM Sans',sans-serif;color:#fff;overflow-x:hidden;}
.pc-page::before{content:'';position:fixed;inset:0;background-image:linear-gradient(rgba(28,115,186,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(28,115,186,0.05) 1px,transparent 1px);background-size:52px 52px;pointer-events:none;z-index:0;}
.pc-nav{position:sticky;top:0;z-index:50;display:flex;align-items:center;justify-content:space-between;padding:0 5%;height:68px;background:rgba(6,17,43,0.9);backdrop-filter:blur(20px);border-bottom:1px solid var(--border);}
.pc-logo{font-family:'Clash Display',sans-serif;font-size:1.5rem;font-weight:700;color:#fff;text-decoration:none;}
.pc-logo span{color:var(--gold);}
.pc-back{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:7px 14px;color:rgba(255,255,255,0.75);font-size:0.85rem;cursor:pointer;text-decoration:none;transition:background 0.2s;}
.pc-back:hover{background:rgba(255,255,255,0.12);color:#fff;}
.pc-hero{padding:64px 5% 40px;position:relative;z-index:1;max-width:1200px;margin:0 auto;}
.pc-eyebrow{display:inline-flex;align-items:center;gap:8px;background:rgba(245,166,35,0.12);border:1px solid rgba(245,166,35,0.3);border-radius:99px;padding:5px 14px;font-size:0.72rem;font-weight:700;color:var(--gold);letter-spacing:2px;text-transform:uppercase;margin-bottom:20px;}
.pc-eyebrow-dot{width:6px;height:6px;border-radius:50%;background:var(--gold);animation:pcPulse 2s infinite;}
@keyframes pcPulse{0%,100%{box-shadow:0 0 0 0 rgba(245,166,35,0.4);}50%{box-shadow:0 0 0 5px rgba(245,166,35,0);}}
.pc-h1{font-family:'Clash Display',sans-serif;font-size:clamp(2rem,3.5vw + 0.5rem,3.2rem);font-weight:700;line-height:1.1;margin-bottom:16px;}
.pc-h1 em{font-style:normal;color:var(--blue3);}
.pc-sub{font-size:1rem;color:rgba(255,255,255,0.6);line-height:1.7;max-width:560px;margin-bottom:0;}
/* Filter tabs */
.pc-filter-row{display:flex;gap:8px;flex-wrap:wrap;margin-top:32px;}
.pc-filter-btn{padding:8px 18px;border-radius:99px;border:1px solid var(--border);background:transparent;color:rgba(255,255,255,0.6);font-family:'DM Sans',sans-serif;font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;}
.pc-filter-btn.active{background:var(--blue);border-color:var(--blue);color:#fff;}
.pc-filter-btn:hover:not(.active){border-color:rgba(28,115,186,0.35);color:#fff;}
/* Cards grid */
.pc-body{padding:40px 5% 60px;position:relative;z-index:1;max-width:1200px;margin:0 auto;}
.pc-layout{display:grid;grid-template-columns:1fr 380px;gap:40px;align-items:start;}
@media(max-width:960px){.pc-layout{grid-template-columns:1fr;}}
.pc-cards-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:14px;margin-bottom:32px;}
.pc-card-tile{background:rgba(255,255,255,0.03);border:2px solid transparent;border-radius:16px;padding:14px;cursor:pointer;transition:all 0.25s;position:relative;overflow:hidden;}
.pc-card-tile::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--blue),var(--blue3));transform:scaleX(0);transform-origin:left;transition:transform 0.25s;}
.pc-card-tile:hover{border-color:rgba(28,115,186,0.3);transform:translateY(-3px);}
.pc-card-tile:hover::before{transform:scaleX(1);}
.pc-card-tile.selected{border-color:var(--blue3);background:rgba(28,115,186,0.1);}
.pc-card-tile.selected::before{transform:scaleX(1);}
.pc-tile-img{width:100%;height:90px;object-fit:contain;margin-bottom:10px;}
.pc-tile-name{font-family:'Clash Display',sans-serif;font-size:0.85rem;font-weight:700;color:#fff;margin-bottom:3px;}
.pc-tile-price{font-size:0.75rem;color:var(--gold);font-weight:600;}
.pc-tile-desc{font-size:0.72rem;color:var(--muted);margin-top:3px;line-height:1.4;}
/* Carousel */
.pc-carousel{border-radius:22px;overflow:hidden;background:rgba(13,31,69,0.6);border:1px solid rgba(28,115,186,0.2);aspect-ratio:4/3;display:flex;align-items:center;justify-content:center;position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.4);margin-bottom:14px;}
.pc-carousel-img{width:100%;height:100%;object-fit:contain;padding:28px;transition:opacity 0.3s;}
.pc-carousel-nav{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;background:rgba(6,17,43,0.8);border:1px solid var(--border);color:rgba(255,255,255,0.8);font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:5;transition:background 0.2s;}
.pc-carousel-nav:hover{background:rgba(28,115,186,0.3);}
.pc-carousel-nav.prev{left:10px;}
.pc-carousel-nav.next{right:10px;}
.pc-carousel-dots{display:flex;justify-content:center;gap:6px;}
.pc-carousel-dot{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,0.2);border:none;cursor:pointer;transition:background 0.2s,width 0.2s;}
.pc-carousel-dot.active{background:var(--blue3);width:16px;border-radius:99px;}
/* Detail panel */
.pc-detail{background:rgba(255,255,255,0.02);border:1px solid var(--border);border-radius:18px;padding:22px;margin-top:20px;}
.pc-section-label{display:block;font-size:0.72rem;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;color:var(--blue3);margin-bottom:10px;}
.pc-detail-title{font-family:'Clash Display',sans-serif;font-size:1.15rem;font-weight:700;color:#fff;margin-bottom:8px;}
.pc-detail-desc{font-size:0.85rem;color:rgba(255,255,255,0.6);line-height:1.65;margin-bottom:14px;}
.pc-feat-list{display:flex;flex-direction:column;gap:6px;}
.pc-feat-item{display:flex;gap:8px;align-items:flex-start;font-size:0.82rem;color:rgba(255,255,255,0.65);}
.pc-feat-dot{color:var(--gold);font-size:12px;margin-top:1px;flex-shrink:0;}
/* Order panel */
.pc-order{background:rgba(255,255,255,0.03);border:1px solid rgba(28,115,186,0.2);border-radius:20px;padding:28px;position:relative;overflow:hidden;backdrop-filter:blur(16px);}
.pc-order::before{content:'';position:absolute;top:-30%;right:-30%;width:60%;height:60%;background:radial-gradient(circle,rgba(245,166,35,0.06) 0%,transparent 70%);pointer-events:none;}
.pc-price{font-family:'Clash Display',sans-serif;font-size:2.2rem;font-weight:700;color:var(--gold);line-height:1;margin-bottom:4px;}
.pc-price-sub{font-size:0.8rem;color:var(--muted);margin-bottom:20px;}
.pc-field-label{font-size:0.72rem;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:1.5px;display:block;margin-bottom:8px;}
.pc-select{width:100%;padding:11px 14px;background:rgba(255,255,255,0.05);border:1px solid rgba(28,115,186,0.2);border-radius:10px;color:#fff;font-family:'DM Sans',sans-serif;font-size:0.9rem;outline:none;margin-bottom:18px;}
.pc-select option{background:#0d1f45;}
.pc-stepper{display:flex;align-items:center;gap:0;background:rgba(255,255,255,0.05);border:1px solid var(--border);border-radius:10px;overflow:hidden;margin-bottom:20px;width:fit-content;}
.pc-stp-btn{width:42px;height:42px;background:transparent;border:none;color:var(--blue3);font-size:1.2rem;cursor:pointer;transition:background 0.2s;}
.pc-stp-btn:hover{background:rgba(28,115,186,0.15);}
.pc-stp-val{width:52px;text-align:center;background:transparent;border:none;border-left:1px solid var(--border);border-right:1px solid var(--border);color:#fff;font-size:0.95rem;font-weight:600;height:42px;font-family:'DM Sans',sans-serif;}
.pc-btn-gold{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 24px;background:linear-gradient(135deg,var(--gold),var(--gold2));color:var(--navy);border:none;border-radius:10px;font-family:'DM Sans',sans-serif;font-size:0.95rem;font-weight:700;cursor:pointer;transition:transform 0.2s,box-shadow 0.2s;box-shadow:0 6px 24px rgba(245,166,35,0.3);margin-bottom:10px;}
.pc-btn-gold:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(245,166,35,0.4);}
.pc-btn-sec{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:12px 24px;background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.8);border:1px solid rgba(255,255,255,0.14);border-radius:10px;font-family:'DM Sans',sans-serif;font-size:0.9rem;font-weight:600;cursor:pointer;transition:background 0.2s,transform 0.2s;}
.pc-btn-sec:hover{background:rgba(255,255,255,0.12);transform:translateY(-2px);}
/* General features */
.pc-general-feats{padding:64px 5%;background:rgba(6,17,43,0.5);border-top:1px solid var(--border);border-bottom:1px solid var(--border);position:relative;z-index:1;}
.pc-general-inner{max-width:1100px;margin:0 auto;}
.pc-general-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:16px;margin-top:32px;}
.pc-gen-card{background:rgba(255,255,255,0.03);border:1px solid var(--border);border-radius:16px;padding:20px;transition:border-color 0.3s,transform 0.3s;position:relative;overflow:hidden;}
.pc-gen-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--gold),var(--gold2));transform:scaleX(0);transform-origin:left;transition:transform 0.3s;}
.pc-gen-card:hover{border-color:rgba(245,166,35,0.3);transform:translateY(-3px);}
.pc-gen-card:hover::before{transform:scaleX(1);}
.pc-gen-icon{font-size:24px;margin-bottom:8px;display:block;}
.pc-gen-title{font-family:'Clash Display',sans-serif;font-size:0.9rem;font-weight:700;color:#fff;margin-bottom:4px;}
.pc-gen-desc{font-size:0.8rem;color:rgba(255,255,255,0.5);line-height:1.55;}
/* Modal */
.pc-modal-overlay{position:fixed;inset:0;z-index:200;background:rgba(6,17,43,0.88);backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;padding:24px;}
.pc-modal{background:linear-gradient(145deg,var(--navy2),var(--navy3));border:1px solid rgba(28,115,186,0.3);border-radius:24px;padding:36px;max-width:480px;width:100%;box-shadow:0 24px 80px rgba(0,0,0,0.6);position:relative;}
.pc-modal-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.08);border:none;color:rgba(255,255,255,0.6);font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s;}
.pc-modal-close:hover{background:rgba(255,255,255,0.15);color:#fff;}
.pc-demo-scene{display:flex;align-items:center;justify-content:center;gap:28px;padding:20px 0;}
.pc-demo-card-img{width:100px;height:65px;border-radius:8px;object-fit:contain;border:2px solid var(--border);}
.pc-demo-phone{width:130px;height:250px;background:#0a0a0a;border-radius:20px;border:2px solid #333;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 16px 40px rgba(0,0,0,0.6);}
.pc-demo-bar{height:26px;background:#111;display:flex;align-items:center;justify-content:center;}
.pc-demo-notch{width:44px;height:7px;background:#222;border-radius:99px;}
.pc-demo-screen{flex:1;background:#0d1f45;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:8px;gap:6px;}
.pc-demo-msg{font-size:9px;color:var(--blue3);text-align:center;font-weight:600;animation:pcFadePulse 1s infinite;}
@keyframes pcFadePulse{0%,100%{opacity:1}50%{opacity:0.4}}
.pc-demo-profile{display:flex;flex-direction:column;align-items:center;gap:4px;width:100%;}
.pc-demo-avatar{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,var(--blue),var(--blue3));display:flex;align-items:center;justify-content:center;font-size:14px;color:#fff;font-weight:700;}
.pc-demo-name{font-size:9px;color:#fff;font-weight:700;}
.pc-demo-role{font-size:7px;color:var(--muted);}
.pc-demo-chips{display:flex;gap:3px;flex-wrap:wrap;justify-content:center;}
.pc-demo-chip{font-size:6px;padding:2px 5px;border-radius:99px;background:rgba(28,115,186,0.2);color:var(--blue3);border:1px solid rgba(28,115,186,0.3);}
.pc-toast{position:fixed;bottom:28px;left:50%;transform:translateX(-50%);background:rgba(13,31,69,0.97);color:#fff;border:1px solid var(--border);border-radius:10px;padding:12px 22px;font-size:0.85rem;font-weight:600;z-index:300;box-shadow:0 8px 32px rgba(0,0,0,0.4);animation:pcToastUp 0.3s ease;}
@keyframes pcToastUp{from{transform:translateX(-50%) translateY(10px);opacity:0;}}
`;

const VARIANTS = [
  { type:'Paper',      price:999,  nfc:false, frontImg:'/images/paperCard_front.png',     backImg:'/images/paperCard_back.png',   desc:'Lightweight & eco-friendly — ideal for events or short-term networking.', features:['Recyclable paper material','QR code for digital profile access','Cost-effective for bulk orders','Custom print design','Eco-friendly choice'] },
  { type:'Plastic',    price:1499, nfc:true,  frontImg:'/images/plasticCard_front.png',   backImg:'/images/plasticCard_back.png', desc:'Classic durable card — water-resistant for daily carry.',               features:['Durable PVC construction','Embedded NFC chip','Water-resistant','Fully customizable design','Daily carry ready'] },
  { type:'Wood',       price:2499, nfc:true,  frontImg:'/images/woodCard_front.png',      backImg:'/images/woodCard_back.png',   desc:'Unique eco-friendly artisan feel with embedded NFC.',                   features:['Natural sustainable wood','Unique texture & look','Embedded NFC chip','Custom engrave options','Premium artisan feel'] },
  { type:'Metal',      price:3499, nfc:true,  frontImg:'/images/metalCard_front.png',     backImg:'/images/metalCard_back.png',  desc:'Sleek metal card that makes a lasting first impression.',               features:['Sturdy metal build','Professional look','Embedded NFC','Custom engravings','Links to digital profile'] },
  { type:'Black Metal',price:3499, nfc:true,  frontImg:'/images/blackmetalCard_front.png',backImg:'/images/blackmetalCard_back.png',desc:'Matte black elegance — the ultimate power move in networking.',         features:['Black metal finish','Premium sophistication','Embedded NFC','Custom design','Compatible with Flap system'] },
  { type:'Social',     price:1499, nfc:true,  frontImg:'/images/reviewCard.png',          backImg:'/images/instafaceCard.png',  desc:'Optimised for social media — direct links to Instagram, LinkedIn & more.', features:['Social media optimised','NFC quick-share','Custom social handles','Boosts online presence','Dual face design'] },
];
const GENERAL_FEATURES = [
  { icon:'📲', title:'Universal NFC', desc:'Works with any NFC-capable smartphone, no app needed.' },
  { icon:'🎨', title:'Custom Branding',desc:'Your logo, colors, and design printed to perfection.' },
  { icon:'♻️', title:'Eco Options',    desc:'Paper and Wood variants help reduce paper waste.' },
  { icon:'🔗', title:'Flap Profile',   desc:'Every card links to your full Flap digital profile.' },
  { icon:'📊', title:'Analytics',      desc:'See how many people tap or scan your card in real-time.' },
];
const FILTERS = ['All','Paper','Plastic','Wood','Metal','Social'];
const fmt = n => `Rs. ${n.toLocaleString('en-IN')}`;

export default function Physicalcard() {
  const [selected, setSelected] = useState(VARIANTS[1]);
  const [imgIdx,   setImgIdx]   = useState(0);
  const [filter,   setFilter]   = useState('All');
  const [color,    setColor]    = useState('black');
  const [qty,      setQty]      = useState(1);
  const [toast,    setToast]    = useState('');
  const [demo,     setDemo]     = useState(false);
  const [demoStep, setDemoStep] = useState(0);
  const timerRef = useRef(null);

  const imgs = [selected.frontImg, selected.backImg].filter(Boolean);
  const filtered = filter==='All' ? VARIANTS : VARIANTS.filter(v => v.type.toLowerCase().includes(filter.toLowerCase()));

  useEffect(() => {
    clearInterval(timerRef.current);
    setImgIdx(0);
    if (imgs.length > 1) timerRef.current = setInterval(() => setImgIdx(i => (i+1)%imgs.length), 4200);
    return () => clearInterval(timerRef.current);
  }, [selected, imgs.length]);

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''), 2800); };

  const handleOrder = () => {
    showToast('Opening WhatsApp…');
    const msg = `Hi! I'd like to order ${qty} ${color} ${selected.type} Flap Card(s) at ${fmt(selected.price)} each. Total: ${fmt(qty*selected.price)}.`;
    setTimeout(() => window.open(`https://wa.me/9779802365432?text=${encodeURIComponent(msg)}`, '_blank'), 900);
  };

  const handleDemo = () => {
    if (selected.type === 'Paper') { showToast('Paper cards use QR scan — no NFC demo available.'); return; }
    setDemo(true); setDemoStep(1);
    setTimeout(()=>setDemoStep(2), 800);
    setTimeout(()=>setDemoStep(3), 1600);
  };

  return (
    <div className="pc-page">
      <style>{STYLES}</style>
      <nav className="pc-nav">
        <a href="/" className="pc-logo">flap<span>.</span></a>
        <a href="/" className="pc-back">← Back to home</a>
      </nav>

      {/* Hero */}
      <section className="pc-hero">
        <div className="pc-eyebrow"><span className="pc-eyebrow-dot"/>NFC Business Cards</div>
        <h1 className="pc-h1">Physical <em>Flap Cards</em></h1>
        <p className="pc-sub">Professional business cards with NFC technology built in. One tap shares your entire digital profile — no app, no friction.</p>
        <div className="pc-filter-row">
          {FILTERS.map(f => (
            <button key={f} className={`pc-filter-btn ${filter===f?'active':''}`} onClick={()=>setFilter(f)}>{f}</button>
          ))}
        </div>
      </section>

      {/* Body */}
      <div className="pc-body">
        <div className="pc-layout">
          {/* Left: grid + detail */}
          <div>
            <div className="pc-cards-grid">
              {filtered.map(v => (
                <div key={v.type} className={`pc-card-tile ${selected.type===v.type?'selected':''}`}
                  onClick={()=>{ setSelected(v); setImgIdx(0); }}>
                  <img src={v.frontImg} alt={v.type} className="pc-tile-img"/>
                  <div className="pc-tile-name">{v.type}</div>
                  <div className="pc-tile-price">{fmt(v.price)}</div>
                  <div className="pc-tile-desc">{v.nfc?'NFC + QR':'QR only'}</div>
                </div>
              ))}
            </div>

            {/* Carousel for selected */}
            <div className="pc-carousel">
              <img src={imgs[imgIdx]} alt={selected.type} className="pc-carousel-img"/>
              {imgs.length > 1 && <>
                <button className="pc-carousel-nav prev" onClick={()=>setImgIdx(i=>(i-1+imgs.length)%imgs.length)}>‹</button>
                <button className="pc-carousel-nav next" onClick={()=>setImgIdx(i=>(i+1)%imgs.length)}>›</button>
              </>}
            </div>
            {imgs.length > 1 && (
              <div className="pc-carousel-dots" style={{ marginTop:10 }}>
                {imgs.map((_,i) => <button key={i} className={`pc-carousel-dot ${i===imgIdx?'active':''}`} onClick={()=>setImgIdx(i)}/>)}
              </div>
            )}

            {/* Detail */}
            <div className="pc-detail" style={{ marginTop:18 }}>
              <span className="pc-section-label">About this variant</span>
              <div className="pc-detail-title">{selected.type} Card</div>
              <div className="pc-detail-desc">{selected.desc}</div>
              <div className="pc-feat-list">
                {selected.features.map(f => (
                  <div key={f} className="pc-feat-item">
                    <span className="pc-feat-dot">✓</span>{f}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: order */}
          <div className="pc-order">
            <span className="pc-section-label">Order</span>
            <div className="pc-price">{fmt(selected.price)}</div>
            <div className="pc-price-sub">{selected.type} Flap Card · {selected.nfc?'NFC + QR':'QR only'}</div>

            <label className="pc-field-label">Color finish</label>
            <select className="pc-select" value={color} onChange={e=>setColor(e.target.value)}>
              <option value="black">Black</option>
              <option value="white">White</option>
              <option value="gold">Gold</option>
              <option value="custom">Custom</option>
            </select>

            <label className="pc-field-label">Quantity</label>
            <div className="pc-stepper">
              <button className="pc-stp-btn" onClick={()=>setQty(q=>Math.max(1,q-1))}>−</button>
              <input className="pc-stp-val" type="number" value={qty} min="1" onChange={e=>setQty(Math.max(1,+e.target.value))}/>
              <button className="pc-stp-btn" onClick={()=>setQty(q=>q+1)}>+</button>
            </div>
            <div style={{ fontSize:'0.8rem', color:'var(--muted)', marginBottom:20 }}>
              Total: <strong style={{color:'var(--gold)'}}>{fmt(qty * selected.price)}</strong>
            </div>

            <button className="pc-btn-gold" onClick={handleOrder}>📱 Order via WhatsApp</button>
            {selected.nfc
              ? <button className="pc-btn-sec" onClick={handleDemo}>▶ NFC Demo</button>
              : <button className="pc-btn-sec" onClick={()=>showToast('Paper cards: just point any camera at the QR code!')}>📷 QR Demo</button>
            }

            <div style={{ marginTop:22, paddingTop:18, borderTop:'1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontSize:'0.72rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, marginBottom:10 }}>Includes</div>
              {['Card printed & delivered','NFC pre-programmed','Flap profile linked','Custom design review'].filter((_,i)=>selected.nfc||i!==1).map(i=>(
                <div key={i} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:7 }}>
                  <span style={{ color:'var(--gold)', fontSize:12 }}>✓</span>
                  <span style={{ fontSize:'0.82rem', color:'rgba(255,255,255,0.6)' }}>{i}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* General features */}
      <section className="pc-general-feats">
        <div className="pc-general-inner">
          <span className="pc-section-label">Why Flap Cards</span>
          <h2 style={{ fontFamily:"'Clash Display',sans-serif", fontSize:'clamp(1.5rem,2.5vw,2.2rem)', fontWeight:700, color:'#fff', marginBottom:0 }}>
            Every card, <span style={{color:'var(--gold)'}}>smarter</span>
          </h2>
          <div className="pc-general-grid">
            {GENERAL_FEATURES.map(f=>(
              <div className="pc-gen-card" key={f.title}>
                <span className="pc-gen-icon">{f.icon}</span>
                <div className="pc-gen-title">{f.title}</div>
                <div className="pc-gen-desc">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Demo modal */}
      {demo && (
        <div className="pc-modal-overlay" onClick={e=>{ if(e.target===e.currentTarget){setDemo(false);setDemoStep(0);}}}>
          <div className="pc-modal">
            <button className="pc-modal-close" onClick={()=>{setDemo(false);setDemoStep(0);}}>✕</button>
            <h3 style={{ fontFamily:"'Clash Display',sans-serif", fontSize:'1.25rem', fontWeight:700, color:'#fff', marginBottom:6 }}>Tap to Share</h3>
            <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:20 }}>Hold your {selected.type} card near any NFC phone to instantly share your profile.</p>
            <div className="pc-demo-scene">
              <img src={selected.frontImg} alt={selected.type} className="pc-demo-card-img"
                style={{ transform:demoStep>=2?'translateX(14px) scale(0.95)':'none', transition:'transform 0.5s' }}/>
              <div style={{ fontSize:20, color:'var(--blue3)', animation:demoStep>=2?'pcFadePulse 0.8s 2':'none' }}>→</div>
              <div className="pc-demo-phone">
                <div className="pc-demo-bar"><div className="pc-demo-notch"/></div>
                <div className="pc-demo-screen">
                  {demoStep===1 && <div className="pc-demo-msg">📡 Tap detected…</div>}
                  {demoStep===2 && <div className="pc-demo-msg">⚡ NFC Card read!</div>}
                  {demoStep>=3 && (
                    <div className="pc-demo-profile">
                      <div className="pc-demo-avatar">F</div>
                      <div className="pc-demo-name">Your Name</div>
                      <div className="pc-demo-role">flap.com.np/you</div>
                      <div className="pc-demo-chips">
                        {['LinkedIn','Email','Phone'].map(l=><span key={l} className="pc-demo-chip">{l}</span>)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {demoStep>=3
              ? <button className="pc-btn-gold" style={{ marginTop:16 }} onClick={handleOrder}>Order Now — {fmt(selected.price)}</button>
              : <button className="pc-btn-sec" style={{ marginTop:16 }} onClick={handleDemo}>▶ Restart</button>
            }
          </div>
        </div>
      )}

      {toast && <div className="pc-toast">{toast}</div>}
    </div>
  );
}